{
  "common": {
    "appname": "Uska",

    "beta": "",

    "login": "Je me connecte",
    "logout": "Je me déconnecte",

    "send": "Envoyer",

    "devise": "€",

    "days": {
      "0": "Lundi",
      "1": "Mardi",
      "2": "Mercredi",
      "3": "Jeudi",
      "4": "Vendredi",
      "5": "Samedi",
      "6": "Dimanche"
    },

    "cancel": "Annuler",
    "save": "Enregistrer",

    "cgu_confirm": "Je confirme avoir pris connaissance des",
    "cgu": "conditions générales",

    "specials_rules_title": "Spécificités des plateformes",

    "premium_button": "Découvrir les abonnements",
    "checklist_premium_button": "Demandez votre bilan de visibilité",
    "short_premium_button": "Passer premium",

    "notifications": {
      "NEW_REVIEW": "Nouvel avis",
      "CMAJ": "Demande de mise à jour",
      "CADH": "Demande de partenariat",
      "TIC_ANSWER": "Votre OT vous répond",
      "TIC": "Votre OT vous sollicite",
      "REMOVED_SECONDARY_CATEGORY": "Catégorie secondaire supprimée",
      "SYNC_GOOGLE_ADDRESS": "Adresse mise à jour",
      "REMOVE_ATTRIBUTE": "Attribut supprimé",
      "NEW_ATTRIBUTE": "Nouveaux attributs disponibles",
      "LATE_SYNC": "Suivi du délai de mise à jour",
      "FACEBOOK_MISSING_PERMISSION": "Permissions administrateur Facebook manquantes",
      "FACEBOOK_CHANGED_PASSWORD": "Changement de mot de passe Facebook",
      "GOOGLE_MISSING_PERMISSION": "Permissions administrateur Google manquantes"
    },

    "lang": {
      "en": "Anglais",
      "fr": "Français"
    },

    "roles": {
      "ADMIN": "Administrateur",
      "EDITOR": "Editeur",
      "GOD": "Tout puissant"
    },

    "format": {
      "ago": "il y a {duration} {unit}",
      "step_init": "Étape {current}",
      "step_end": "sur {total}"
    },

    "features": {
      "REVIEW": "Avis et commentaires",
      "PUBLICATION": "Publications",
      "INFORMATION": "Informations"
    },

    "form": {
      "upload_media_loading": "Téléchargement en cours",

      "password_validation_rules": {
        "minimum_required_characters": "8 caractères minimum",
        "required_letters": "Au moins 1 majuscule et 1 minuscule",
        "required_number": "Au moins 1 chiffre",
        "required_special": {
          "part_1": "Au moins 1 caractère spécial (sauf ",
          "characters": ["\"", "'", "="],
          "part_2": ")"
        }
      },

      "contact_message": {
        "label": "Message",
        "placeholder": "Expliquez votre besoin",
        "size_message": "{nb} / {total}"
      },

      "mobile_select_help": "Saisissez le mot de votre choix, et appuyez sur espace pour l'ajouter à la liste",

      "tags": {
        "placeholder": "Commencez à taper un mot"
      },

      "establishment_name": {
        "label": "Nom de votre établissement",
        "placeholder": "ex: Hôtel de ville"
      },

      // Widget de sélection de date / heure

      "date_picker": {
        "cancel_button": "Annuler",
        "save_button": "Confirmer"
      },

      // Identity

      "firstname": {
        "label": "Prénom",
        "placeholder": "Bernard"
      },

      "lastname": {
        "label": "Nom",
        "placeholder": "DUPONT"
      },

      // Password

      "password": {
        "label": "Mot de passe",
        "placeholder": "",
        "secure_link": "+ d'infos",
        "modal_title": "Pourquoi devez-vous renseigner un mot de passe robuste ?",
        "modal_description": "C'est pour votre bien ! Vos informations en ligne sont sensibles. Pour bien les protéger, nous avons besoin d'un mot de passe sécurisé. "
      },

      "confirm_password": {
        "label": "Confirmer mon mot de passe",
        "placeholder": ""
      },

      // Addresse

      "address": {
        "label": "Adresse",
        "placeholder": "Rue et numéro de rue de votre établissement"
      },

      "postal_code": {
        "label": "Code postal",
        "placeholder": "38 000"
      },

      "city": {
        "label": "Commune",
        "no_options_text": "Entrez le nom d'une commune",
        "no_results_text": "Aucun résultat",
        "placeholder": "ex: Grenoble"
      },

      "country": {
        "label": "Pays",
        "no_options_text": "Entrez le nom d'un pays",
        "no_results_text": "Aucun résultat",
        "placeholder": "ex: France"
      },

      // Communications

      "phone": {
        "label": "Numéro de téléphone",
        "placeholder": "06 00 00 00 00"
      },

      "email": {
        "label": "Adresse e-mail",
        "placeholder": "bernard.dupont{'@'}gmail.com",
        "legend": "Pour modifier votre adresse e-mail, veuillez nous contacter"
      },

      "url": {
        "label": "Lien",
        "placeholder": "https://mon-site.fr"
      }
    },

    "messages": {
      "account_created_successfully": "Votre compte a été créé avec succès",
      "validation_mail_sent": "Un email de confirmation a été renvoyé"
    },

    "errors": {
      "default": "Une erreur est survenue",
      "hubo_server_error": "Nos serveurs tentent de se reconnecter...",
      "uberall_server_error": "Nos serveurs tentent de se reconnecter...",

      // User
      "user_access": "Vous n'avez pas les droits pour effectuer cette action",
      "no_connected_user": "Nous avons des difficultés à vous identifier. Veuillez vous reconnecter",
      "no_connected_user_title": "Aucun utilisateur connecté",
      "user_session_expired": "Pour des raisons de sécurité, veuillez vous reconnecter",
      "user_session_invalid": "Nous avons des difficultés à vous identifier. Veuillez vous connecter",
      "no_account_id": "Nous avons des difficultés à retrouver votre identifiant de compte. Veuillez nous contacter",

      // Form
      "form": "Le formulaire comporte des erreurs",

      // Establishment
      "no_establishment": "Nous avons des difficultés à retrouver votre établissement",
      "no_city": "Nous avons des difficultés à récupérer la commune et le code postal",
      "media_too_large": "Votre image est trop grande",
      "media_too_small": "Votre image est trop petite",
      "damaged_file": "Votre fichier est endommagé ou votre image n'a pas été transmise",

      // Authentication
      "email_already_in_used": "Un compte Uska existe déjà avec cette adresse e-mail",
      "email_unknown": "Cette adresse e-mail est inconnue",
      "account_already_exist": "Vous avez déjà un compte Uska avec une autre adresse email",
      "need_revoke": "Un problème a été renconntré lors de la validation des permissions. Supprimez vos permissions sous le nom de Uska sur ",
      "need_revoke_url": "cette page",

      // Onboarding
      "empty_diffusers_list": "Nous avons des difficultés à retrouver les pages à analyser",
      "empty_sources_list": "Nous avons des difficultés à récupérer vos pages",
      "need_more_establishment_info": "Nous avons besoin de plus d'informations à propos de votre établissement",
      "bad_analyse": "Nous avons des difficultés à analyser vos informations car nous n'avons pas trouvé assez d'informations sur vos pages",
      "bad_score": "Nous avons des difficultés à calculer votre score de visibilité car nous n'avons pas trouvé assez d'informations sur vos pages",
      "missing_city": "La commune est manquante",

      // Erreurs de connexion à Google / Facebook (code uberall)
      "default_connexion_error": "Nous n'avons pas trouvé la source du problème. Contactez-nous, nous vous répondrons dans les plus brefs délais.",
      "missing_permissions_connexion_error": "Vous devez accepter les permissions pour terminer la connexion à {diffuser}.",
      "modal_error_title": "Une erreur est survenue lors de la connexion à {diffuser}",
      "MISSING_googleCode": "L’URL de connexion est incorrecte. Veuillez réessayer",
      "INVALID_googleCode": "L’URL de connexion est expirée. Veuillez réessayer",
      "MISSING_googleAccount": "",
      "NOT_CONNECTED": "Nous ne trouvons pas votre compte Google. Veuillez réessayer",
      "INVALID_id": "L’URL de connexion est incorrecte. Veuillez réessayer",
      "MISSING_pageId": "L’URL de connexion est incorrecte. Veuillez réessayer",
      "MISSING_whitelisted_redirectUrl": "Nous avons des difficultés à vous redirigez sur @:common.appname",
      "INVALID_pageId": "L’URL de connexion est incorrecte. Veuillez réessayer",
      "noMethod": "Google semble refuser la connexion"
    },

    "contact_panel": {
      "description": "Un problème ? Une question ?",
      "button": "Nous contacter"
    },

    "contact_success_message": "Message envoyé !"
  },

  "validations": {
    "required": "Ce champ est obligatoire",
    "requiredIf": "Ce champ est obligatoire sans {other}",
    "numeric": "Ce champ doit contenir uniquement des chiffres",
    "url": "Ce champ doit être au format url (https://...)",
    "plateform_url": "Ce champ doit respecter le format de la plateforme",
    "email": "Ce champ doit être au format e-mail",
    "phone": "Ce champ doit être au format numéro de téléphone",
    "postal_code": "Ce champ doit être au format code postal",
    "password": "Ce champ doit être au format mot de passe",
    "sameAsPassword": "Ce mot de passe doit correspondre au premier",
    "special": "Vous avez ajouté un caractère non autorisé par Google (ex: %${'@'}\\)",
    "uppercase": "Selon les recommandations de Google, votre nom d'établissement ne doit pas être entièrement en majuscule",
    "emoji": "Vous avez ajouté un emoji qui n'est pas pris en compte par les plateformes. Pour nous permettre de mettre à jour, il faut l'enlever ou le remplacer par un autre.",
    "keywords": "Vous ne pouvez pas ajouter plus de 10 mots clés",
    "long_description": "Votre description est trop longue et ne dois pas dépasser 750 caractères"
  },

  "menu": {
    "dropdown": {
      "profile": {
        "admin": "Mon profil",
        "editor": "Mon profil"
      },
      "subscription": {
        "admin": "Abonnement",
        "editor": "Abonnement"
      },
      "management": {
        "admin": "Gérer les utilisateurs",
        "editor": "Utilisateurs"
      },
      "contact": {
        "admin": "Contactez-nous",
        "editor": "Contactez-nous"
      },
      "newestablishment": {
        "admin": "Nouvel établissement",
        "editor": "Nouvel établissement"
      }
    },

    "app": {
      "dashboard": "Mon tableau de bord",
      "establishments": "Mes informations",
      "publications": "Mes publications",
      "reviews": "Mes avis et commentaires",
      "analyse": "Mon analyse",
      "solicitations": "Mes sollicitations"
    }
  },

  "error": {
    "title": "Quelque chose n’a pas fonctionné...",
    "message": "Nous mettons tout en oeuvre pour faire revenir @:common.appname dans les meilleurs délais"
  },

  "anecdotes": [
    "86% des consommateurs utilisent Google Maps pour trouver un service autour d'eux",
    "95 % des voyageurs lisent un ou plusieurs avis avant d’effectuer une réservation",
    "92% des internautes vont choisir la première fiche Maps qui apparaît dans leurs résultats",
    "La recherche locale sur Internet est 300% plus importante que les réseaux sociaux",
    "Uska diffuse vos informations sur 50 plateformes et améliore ainsi le référencement de votre fiche Google",
    "Avec Uska, apprenez en plus sur les bonnes pratiques du référencement local",
    "Répondez à vos avis clients pour améliorer votre référencement",
    "Ne négligez pas les publications sur vos réseaux sociaux, elles comptent dans votre référencement",
    "Avec Uska, booster votre référencement local et gagner plus de client en direct",
    "Uska, c’est une solution clef en main ainsi qu’un accompagnement humain personnalisé, pour améliorer votre référencement"
  ],

  "home": {
    "main_title": "Mon tableau de bord",

    "middleware_message": {
      "default": "Votre établissement ne peux pas voir ses statistiques",
      "unvalidated_establishment": "Vous serez contacté par mail pour valider votre paiement et activer votre établissement. Si besoin, n’hésitez pas à contacter l’équipe support via le chat en bas à droite de l’écran"
    },

    "success_connexion_message": "La connexion à {diffuser} a bien fonctionné",

    "temporary_message_stats_delay": "Vos statistiques peuvent mettre jusqu'à 7 jours pour apparaître après votre connexion à Google ou Facebook",
    "temporary_message_connect": "Vos statistiques seront accessibles une fois que vous serez connecté à Google ou Facebook",
    "temporary_message_need_google_connection": "Une action est requise pour votre fiche Google",

    "checklist": {
      "validatedEmail": "Validez votre email",
      "validatedEmail_no_email_received_button": "Je n'ai pas reçu de mail",
      "validatedEmail_how_to_button": "Comment valider mon email ?",
      "validatedEmail_resend_modal": {
        "title": "Vous n'avez pas reçu d'email de validation ?",
        "description": "Pas de panique ! Ça peut arriver. Regardez bien dans vos spams. Si vous ne le trouvez pas, vous pouvez renvoyer un email.",
        "button": "Renvoyer un email"
      },
      "validatedEmail_how_to_modal": {
        "title": "Comment valider mon email ?",
        "description": "Nous avons envoyé un mail à l'adresse email que vous nous avez donné lors de la création de votre compte. Dans ce mail, il faudra juste cliquer sur le lien pour le valider."
      },

      "completedName": "Ajoutez votre nom et prénom",
      "completedName_add_button": "Ajouter",

      "connectedGoogle": "Connectez votre compte Google",
      "connectedGoogle_connect_button": "Se connecter",
      "connectedGoogle_modal": {
        "title": "Comment se connecter à mon compte Google ?",
        "description": "Suivez les indications en choisissant votre compte Google propriétaire de la fiche Google de votre établissement. Votre fiche établissement doit être “vérifiée” par Google pour pouvoir la connecter à Uska. N’hésitez pas à nous contacter pour toute question."
      },

      "connectedFacebook": "Connectez votre compte Facebook",
      "connectedFacebook_connect_button": "Se connecter",
      "connectedFacebook_modal": {
        "title": "Des difficultés pour vous connecter à votre compte Facebook ?",
        "description": "C'est peut-être qu'on a pas trouvé votre fiche",
        "contact_button": "Contactez-nous",
        "contact_form_success_message": "Votre demande d’aide a bien été envoyée"
      },

      "viewedSolicitations": "Consultez vos sollicitations",
      "viewedSolicitations_button": "Voir les sollicitations",

      "analysed": "Lancez une analyse",
      "analysed_button": "Lancer",

      "subscribedToLN": "Recevez nos conseils pour optimiser votre référencement local !",
      "subscribedToLN_button": "Qu'est-ce que c'est ?",
      "subscribedToLN_modal": {
        "title": "Recevez nos conseils pour optimiser votre référencement local !",
        "description": "Un email par semaine pour vous rendre incollable sur la thématique du référencement local. Garanti sans prise de tête, et rempli de nos meilleurs conseils ! Alors, on fait décoller votre fiche Google ensemble ?",
        "button": "Je m'abonne",
        "success_message": "Vous êtes déjà inscrit à notre newsletter avec le mail {mail}"
      },

      "goPremium": "Découvrez les fonctionnalités d'Uska Premium"
    },

    "filter": {
      "period": {
        "title": "Choisir une période",
        "last_week": "7 derniers jours",
        "last_month": "30 derniers jours",
        "last_6_month": "6 derniers mois",
        "last_year": "12 derniers mois",
        "premium": "Passer premium"
      },
      "platform": {
        "title": "Choisir une plateforme",
        "all": "Toutes plateformes",
        "google": "Google",
        "facebook": "Facebook",
        "premium": "Passer premium"
      }
    },

    "global_stats": {
      "title": "Statistiques globales",
      "description": "Période du {startDate} au {endDate} par rapport à la période du {compareStartDate} au {compareEndDate}",
      // "description": "Période : semaine du {startDate} au {endDate}. | Comparé à : semaine précédente."

      "views_title": "Vues",
      "views_description": "Nombre cumulé de vues sur vos pages Google, Google Maps et Facebook.",
      "clics_title": "Clics",
      "clics_description": "Nombre de personnes ayant cliqué sur vos publications Facebook.",
      "note_title": "Note moyenne",
      "note_description": "Note moyenne globale de tous vos avis clients sur Google et Facebook.",
      "note_empty_data": "Vous n'avez reçu aucun avis avec une note sur cette période"
    },

    "profil": {
      "title": "Complétude du profil",
      "description": "Qualité et cohérence de vos informations",
      "info_bubble": "Plus votre profil sera complet, plus vous serez visible sur Google",

      "score_title_under_percent_50": "Vous pouvez progresser !",
      "score_title_under_percent_75": "Encore un petit effort !",
      "score_title_under_percent_100": "Presque au top !",
      "score_title_at_100": "Bravo, votre profil est complet !",

      "score_description": "Complétez ces champs pour améliorer votre profil :",

      // Liste des champs à ajouter pour compléter le profil
      "field_ATTRIBUTES": "caractéristiques",
      "field_KEYWORDS": "mots clés",
      "field_SERVICES": "services",
      "field_EMAIL": "e-mail",
      "field_WEBSITE": "site web",
      "field_OPENINGHOURS": "horaires d'ouverture",
      "field_PHOTOS": "photos",
      "field_DESCRIPTION_SHORT": "description courte",
      "field_DESCRIPTION_LONG": "description longue",
      "field_NAME": "nom de l'établissement",
      "field_PHONE": "numéro de téléphone",
      "field_CATEGORIES": "catégorie principale",
      "field_STREET": "adresse",
      "field_CITY": "ville",
      "field_INSTAGRAM": "Instagram",
      "field_FACEBOOK": "Facebook"
    },

    "synchronisation": {
      "title": "Mise à jour",
      "description_last_sync": "Dernière mise à jour le {date}",
      "description_no_sync": "Vous n'avez jamais lancé de mise à jour",
      "info_bubble": "",

      // Message d'erreur s'affichant lorsqu'on a pas de stats sur la connexion (pas d'établissement par ex)
      "error_message": "Une erreur est survenue lors de la récupération de vos plateformes",

      "connect_button": "Se connecter",

      // Titre du statut, qui s’affiche sur le dashboard (avec l'icône et la couleur correspondante)
      "states": {
        "WAIT_FOR_SYNC": "Non activée",
        "SYNCHRONIZED": "A jour",
        "SUBMITTED": "En cours...",
        "BEING_UPDATED": "En cours...",
        "ERROR_CLAIMED_BY_OTHERS": "Non mis à jour",
        "ERROR_CLAIMED_BY_ANOTHER_US": "Non mis à jour",
        "ERROR_FIELDS": "Non mis à jour",
        "ERROR_NOT_CONNECTED": "Non mis à jour",
        "ERROR_NOT_FOUND": "Non mis à jour",
        "ERROR": "Non mis à jour",

        "PENDING_CONNECTION": "Demande envoyée",
        "CONNECTED": "Connecté",
        "REFUSED": "Demande refusée",
        "IGNORED": "Demande ignorée",

        // Status qui ne devrait pas apparaître, mais dans le cas où on a un problème, ça affiche au moins un message propre
        "undefined": "Plateforme inconnue"
      }
    },

    "plateformes": {
      "title": "Vos plateformes",
      "description": "Total : {nb} plateformes",
      "info_bubble": "",
      "button": "Mes plateformes",

      "freemium_account": "Vous n'êtes pas connecté à vos plateformes",
      "no_data": "Vous n'avez pas encore lancé de mise à jour",

      "states": {
        "success": "A jour",
        "warning": "En cours",
        "error": "En erreur"
      }
    },

    "google": {
      "title": "Vos clients sont sur Google",
      "description": "Statistiques disponibles sur les performance de la fiche Google My Business de votre établissement sur Google Maps et Google Search.",
      "premium_description": "Découvrez le nombre de clics, le nombre de vues et le nombre d'avis laissés sur votre page Google",
      "button-1": "année dernière",

      "not_connected": "Vous devez vous connecter à votre compte Google pour afficher vos statistiques",

      "clicks": {
        "title": "Évolution du nombre de clics",
        "description": "Nombre de personnes ayant cliqué sur un des boutons Itinéraire, Site web ou Téléphone de votre fiche Google Maps ou Google Search. Comment l’interpréter ? Plus vos clics augmentent, plus votre fiche est attractive et/ou ressort haut dans les résultats de recherche.<br>Les barres transparentes représentent l’année dernière.",

        "no_filter": "Sélectionnez un filtre pour afficher vos données",
        "no_data": "Nous n'avons pas d'informations sur le nombre de clics sur cette période",

        "total": "Total : {nb}",
        "previous_total": "L'année dernière : {nb}",

        "legend": {
          "website": "Site Web",
          "website n-1": "Site Web",
          "phone": "Téléphone",
          "phone n-1": "Téléphone",
          "drive": "Itinéraire",
          "drive n-1": "Itinéraire"
        }
      },

      "views": {
        "title": "Évolution du nombre de vues",
        "description": "Nombre de personnes ayant vu votre fiche Google sur Google Maps ou Google Search. Ce graphique affiche la valeur cumulée des vues sur Google Maps et Google Search. <br>Les courbes en pointillée représentent l’année dernière.",

        "no_filter": "Sélectionnez un filtre",
        "no_data": "Nous n'avons pas d'informations sur le nombre de vues sur cette période",

        "total": "Total : {nb}",
        "previous_total": "L'année dernière : {nb}",

        "legend": {
          "maps": "Maps",
          "maps n-1": "Maps",
          "search": "Search",
          "search n-1": "Search"
        }
      },

      "reviews_answers": {
        "title": "Taux de réponse aux avis",
        "description": "Pourcentage des avis auxquels vous avez répondu. Plus vous répondez aux avis, plus vous avez de chance d’améliorer votre référencement. Améliorez donc ce taux au maximum !",
        "no_data": "Nous n'avons pas d'informations sur le nombre d'avis sur cette période",

        "total": "Total : {nb} avis",
        "previous_total": "L'année dernière : {nb} avis",

        "previous_title": "L'année dernière",
        "no_reviews": "Aucun avis sur cette période",

        "legend": {
          "responded": "Avec réponse",
          "not_responded": "Sans réponse"
        }
      },

      "reviews_rating": {
        "title": "Avis par notes",
        "description": "Répartition par note du nombre d’avis reçus sur la période sélectionnée. <br>La complétude du cercle représente la proportion de cette note dans l’ensemble de vos avis. Plus le cercle est plein, plus cette note représente une grande part dans l’ensemble de vos avis.",
        "no_data": "Nous n'avons pas d'informations sur le nombre d'avis sur cette période",
        "no_reviews": "Aucun avis sur cette période",

        "total": "Total : {nb} avis",
        "previous_total": "L'année dernière : {nb} avis"
      }
    },

    "facebook": {
      "title": "Vos clients sont sur Facebook",
      "description": "",
      "premium_description": "Découvrez le nombre de j'aime, le taux d'engagement et qui sont vos fans sur Facebook",
      "button-1": "année dernière",

      "not_connected": "Vous devez vous connecter à votre compte Facebook pour afficher vos statistiques",

      "reviews_answers": {
        "title": "Taux de réponse aux avis",
        "description": "Pourcentage des avis auxquels vous avez répondu. Plus vous répondez aux avis, plus vous avez de chance d’améliorer votre référencement. Améliorez donc ce taux au maximum !",
        "no_data": "Nous n'avons pas d'informations sur le nombre d'avis sur cette période",

        "total": "Total : {nb} avis",
        "previous_total": "L'année dernière : {nb} avis",

        "previous_title": "L'année dernière",
        "no_reviews": "Aucun avis sur cette période",

        "legend": {
          "responded": "Avec réponse",
          "not_responded": "Sans réponse"
        }
      },

      "likes": {
        "title": "Mentions J’aime de votre page",
        "description": "Combien de mentions j’aime votre page a-t-elle gagnées ou perdues au cours de la période ? Les mentions j’aime témoignent de la popularité de votre page et rendent vos posts plus visibles sur Facebook",
        "no_data": "Nous n'avons pas d'informations sur les mentions gagnées et perdues sur cette période",

        "total": "Total : {nb}",
        "previous_total": "L'année dernière : {nb}",

        "previous_title": "L'année dernière",

        "like_removed": "Mentions perdues",
        "like_added": "Mentions gagnées"
      },

      "likes_evolution": {
        "title": "Évolution des mentions",
        "description": "Courbe de progression des mentions j’aime de votre page sur la période sélectionnée. <br>La courbe en pointillée représente l’année dernière.",
        "no_data": "Nous n'avons pas d'informations sur le nombre de mentions sur cette période",

        "total": "Total : {nb}",
        "previous_total": "L'année dernière : {nb}",

        "legend": {
          "likes": "Mentions j'aime",
          "likes n-1": "Mentions j'aime"
        }
      },

      "engagement": {
        "title": "L'engagement sur vos publications",
        "description": "Le taux d’engagement représente le nombre de fois où des personnes ont interagi avec vos publications à travers des réactions, des commentaires ou des partages.<br>La courbe en pointillée représente l’année dernière.",
        "no_data": "Nous n'avons pas d'informations sur le taux d'engagement de vos publications Facebook sur cette période",

        "total": "Total : {nb}",
        "previous_total": "L'année dernière : {nb}",

        "legend": {
          "engagement": "Taux d'engagement",
          "engagement n-1": "Taux d'engagement"
        }
      },

      "follow": {
        "title": "Nombre de followers",
        "description": "Le nombre de followers représente le nombre de personnes ou page Facebook qui suivent votre page.<br>La courbe en pointillée représente l’année dernière.",
        "no_data": "Nous n'avons pas d'informations sur le nombre de followers Facebook sur cette période",

        "total": "Total : {nb}",
        "previous_total": "L'année dernière : {nb}",

        "legend": {
          "follow": "Nombre de followers",
          "follow n-1": "Nombre de followers"
        }
      },

      "like": {
        "title": "Mentions j’aime",
        "description": "",
        "no_data": "Nous n'avons pas d'informations sur le nombre de mentions j'aime sur cette période",

        "total": "Total : {nb}",
        "previous_total": "L'année dernière : {nb}",

        "legend": {
          "like": "Nombre de mentions j’aime",
          "like n-1": "Nombre de mentions j’aime"
        }
      },

      "impression": {
        "title": "Vues de la page",
        "description": "Le nombre de vues représente le nombre de fois où votre page Facebook ou son contenu est apparue sur l’écran d’une personne.<br>La courbe en pointillée représente l’année dernière.",
        "no_data": "Nous n'avons pas d'informations sur le nombre de vues Facebook sur cette période",

        "total": "Total : {nb}",
        "previous_total": "L'année dernière : {nb}",

        "legend": {
          "impression": "Nombre de vues",
          "impression n-1": "Nombre de vues"
        }
      },

      "gender": {
        "title": "Vos fans",
        "description": "Répartition par genre et âge des personnes ayant déposé une mention j’aime sur votre page Facebook.<br>Les barres transparentes représentent l’année dernières.",

        "no_filter": "Sélectionnez un filtre",
        "no_data": "Nous n'avons pas d'informations sur les personnes qui consultent votre page Facebook sur cette période",

        "total": "Total : {nb}",
        "previous_total": "L'année dernière : {nb}",

        "legend": {
          "male": "Hommes",
          "male n-1": "Hommes",
          "female": "Femmes",
          "female n-1": "Femmes"
        }
      },

      "reviews_rating": {
        "title": "Avis par notes",
        "description": "Répartition par note du nombre d’avis reçus sur la période sélectionnée. <br>La complétude du cercle représente la proportion de cette note dans l’ensemble de vos avis. Plus le cercle est plein, plus cette note représente une grande part dans l’ensemble de vos avis.",
        "no_data": "Nous n'avons pas d'informations sur le nombre d'avis sur cette période",
        "no_reviews": "Aucun avis sur cette période",

        "total": "Total : {nb} avis",
        "previous_total": "L'année dernière : {nb} avis"
      }
    }
  },

  // UTILISATEURS

  "profile": {
    "page_title": "@:profile.main_title - @:common.appname",
    "main_title": "@:menu.dropdown.profile.admin",

    // Formulaire information profil (nom + prénom + e-mail)
    "title": "Modifier mes informations",

    "success_message": "Votre profil a été mis à jour",
    "validation_button": "J’enregistre",
    "error_form": "@:common.errors.form",

    "firstname": {
      "label": "@:common.form.firstname.label",
      "placeholder": "@:common.form.firstname.placeholder"
    },

    "lastname": {
      "label": "@:common.form.lastname.label",
      "placeholder": "@:common.form.lastname.placeholder"
    },

    "email": {
      "label": "@:common.form.email.label",
      "placeholder": "@:common.form.email.placeholder"
    },

    "role": {
      "label": "Role"
    },

    // Formulaire de modification du mot de passe
    "update_password": {
      "title": "Modifier mon mot de passe",

      "validation_button": "Je modifie mon mot de passe",
      "button_open_update_password": "Je modifie mon mot de passe",
      "button_close_update_password": "J’annule",

      "success_message": "Votre mot de passe a bien été modifié",
      "error_form": "@:common.errors.form",
      "error_email_needed": "Vous devez saisir une adresse e-mail pour modifier votre mot de passe",
      "error_wrong_password": "Votre mot de passe est incorrect",

      "current_password": {
        "label": "Mot de passe actuel",
        "placeholder": "@:common.form.password.placeholder"
      },

      "password": {
        "label": "@:common.form.password.label",
        "placeholder": "@:common.form.password.placeholder"
      },

      "confirm_password": {
        "label": "@:common.form.confirm_password.label",
        "placeholder": "@:common.form.confirm_password.placeholder"
      }
    },
    "preferences": {
      "title": "Mes préférences"
    },
    "language": {
      "title": "Langue"
    },
    "notifications": {
      "title": "Notifications",
      "frequency_title": "Fréquence",
      "type_title": "Type",
      "email_checkbox": "Email",
      "pwa_checkbox": "Notification push"
    }
  },

  "usermanagement": {
    "page_title": "@:usermanagement.main_title_admin - @:common.appname",

    "main_title_admin": "@:menu.dropdown.management.admin",
    "main_title_editor": "@:menu.dropdown.management.editor",

    "add_user_button": "J’invite un utilisateur",

    "premium_card_title": "Vous souhaitez ajouter des utilisateurs ?",

    // Un utilisateur
    "update_user_button": "Je modifie",
    "delete_user_button": "Je supprime",
    "show_establishments_button": "{nb} établissements",
    "no_establishment_message": "Aucun établissement attribué",

    // Affichage utilisateur version mobile
    "mobile_establishments_title": "Établissements",
    "mobile_features_title": "Fonctionnalités",

    // Modal de confirmation de suppression
    "delete_user_modal_title": "Supprimer un utilisateur",
    "delete_user_modal_cancel_button": "J’annule",
    "delete_user_modal_confirm_button": "Je supprime",
    "delete_user_success": "L'utilisateur a bien été supprimé",

    // Compte inactif
    "inactiv_account_badge": "Compte inactif",
    "inactiv_account_tooltip": "Cet utilisateur ne s'est jamais connecté"
  },

  "newuser": {
    "page_title": "@:newuser.main_title - @:common.appname",

    "main_title": "Nouvel utilisateur",
    "error_form": "@:common.errors.form",

    // Formulaire
    "firstname": {
      "label": "@:common.form.firstname.label",
      "placeholder": "@:common.form.firstname.placeholder"
    },

    "lastname": {
      "label": "@:common.form.lastname.label",
      "placeholder": "@:common.form.lastname.placeholder"
    },

    "email": {
      "label": "@:common.form.email.label",
      "placeholder": "@:common.form.email.placeholder"
    },

    "role": {
      "label": "Role"
    },

    "features_title": "Fonctionnalités",
    "establishments_title": "Établissements",

    // Création d'un utilisateur
    "create_validate_button": "J’invite",
    "create_success_message": "L'utilisateur a été invité",

    // Modification d'un utilisateur
    "created_at": "Ajouté le {date}",
    "update_validate_button": "J’enregistre",
    "waiting_for_create_password_message": "En attente de création de mot de passe",
    "update_success_message": "L'utilisateur a été mis à jour"
  },

  "usermanagement/user": {
    "page_title": "{user} - @:common.appname"
    // go to newuser
  },

  // ABONNEMENT

  "subscriptions": {
    "page_title": "@:subscriptions.main_title - @:common.appname",
    "main_title": "Abonnement",

    "premium_card_title": "Et si on diffusait vos informations sur 50 plateformes ?",

    "subscribed_at": "Souscrit le {date}",
    "per_month": "/ mois",

    "premium_button": "@:common.premium_button",
    "cancel_subscription": "Résilier",

    "disable_establishment": "Désactivé",
    "disable_establishment_tooltip": "En attente de paiement",

    "cancel_modal_title": "Résilier votre abonnement",
    "cancel_modal_sucess": "La demande de résiliation a bien été envoyée",

    "empty_subscriptions_title": "Vous n'avez aucun abonnement en cours",
    "empty_subscriptions_message": "Contactez-nous pour en discuter !"
  },

  // PUBLICATIONS

  "publications": {
    "page_title": "@:publications.main_title - @:common.appname",
    "main_title": "Mes publications",

    "middleware_message": {
      "default": "Votre établissement ne peux pas voir ses publications et créer de nouveaux posts",
      "unvalidated_establishment": "Vous serez contacté par mail pour valider votre paiement et activer votre établissement. Si besoin, n’hésitez pas à contacter l’équipe support via le chat en bas à droite de l’écran",
      "unauthorized_access": "Votre établissement n'a pas les droits pour voir ses publications et créer de nouveaux posts"
    },

    "freemium_message": "Oups ! Pour publier sur l’ensemble de vos réseaux sociaux en 1 clic, découvrez nos offres",
    "freemium_button": "Découvrir nos offres",

    "new_publication_button": "Créer une publication",

    "read_more": "Lire la suite",

    // Onglet de toutes les publications en brouillon
    "drafts": {
      "tab_title": "Brouillons",

      "publish_button": "Publier",

      // Badge bleu sur les cartes des publications pour indiquer que c'est un brouillon
      "draft_tag": "Brouillon",

      "empty_drafts_list_title": "Aucun brouillon trouvé",
      "empty_drafts_list_message": "Adaptez les filtres ou créez une nouvelle publication"
    },

    // Onglet de toutes les publications publiées ou planifiées
    "published": {
      "tab_title": "Publiées",

      // Badges indiquant le statut de la publication
      "published_at_tag": "Publiée le {date}",
      "send_at_tag": "Envoyée le {date}",
      "planified_at_tag": "Planifiée pour le {date}",

      "empty_list_title": "Aucune publication trouvée",
      "empty_list_message": "Adaptez les filtres ou créez une nouvelle publication"
    },

    "show_publication_modal_edit_button": "Modifier",
    "show_publication_modal_cancel_button": "Fermer",

    "delete_publication_modal_title": "Supprimer la publication",
    "delete_publication_modal_message": "Vous allez supprimer définitivement la publication sur l'ensemble des plateformes",
    "delete_publication_modal_cancel_button": "Annuler",
    "delete_publication_modal_confirm_button": "Supprimer",

    "publish_publication_modal_title": "Publier maintenant",
    "publish_publication_modal_error": "Vous ne pouvez pas publier votre post sans ajouter du contenu sur au moins 1 plateforme.",
    "publish_publication_modal_cancel_button": "Annuler",
    "publish_publication_modal_confirm_button": "Valider",

    "filters_sidebar_title": "Critères de recherche"
  },

  "publications/form": {
    "page_title": {
      "DRAFT": "@:publications/form.create_main_title - @:common.appname",
      "PUBLISHED": "@:common.appname - @:publications/form.update_main_title"
    },

    // Message à côté du switch pour désactiver la publication d’une plateforme non connectée
    "not_connected_mesage": "Vous n’êtes pas connecté à {diffuser}",

    "create_main_title": "Nouvelle publication",
    "update_main_title": "Modifier une publication",

    "publication_title": {
      "label": "Titre de votre publication",
      "placeholder": "",
      "tooltip_description": "Seul vous pouvez consulter le titre, il ne sera pas partagé dans les publications sur vos réseaux sociaux"
    },

    "content": {
      "label": "Contenu",
      "placeholder": "Ecrivez ici votre publication"
    },

    "hashtags": {
      "label": "Hashtags"
    },

    "medias": {
      "label": "Medias",
      "alert_message": "Vous pouvez glisser/déposer les images pour modifier leur ordre d'affichage",
      "delete_photo_tooltip": "Supprimer la photo",
      "drag_and_drop_message": "Glissez/déposez pour réorganiser",
      "add_media_button": "Ajouter une photo",

      "crop_modal_title": "Ajouter une photo",
      "crop_modal_message": "Vous pouvez rogner votre photo",
      "crop_modal_cancel_button": "Annuler",
      "crop_modal_save_button": "Enregistrer"
    },

    "link": {
      "label": "Lien",
      "alert_message": "Le format du lien doit débuter par http:// ou https://. Vous pouvez copier-coller l’URL de votre événement",
      "placeholder": "https://www.mon-site.fr/"
    },

    "preview": {
      "mobile_tab_title": "Mobile",
      "desktop_tab_title": "Ordinateur",

      "google": {
        "published_date": "À l'instant"
      },

      "facebook": {
        "published_date": "À l'instant",
        "like": "J'aime",
        "comment": "Commenter",
        "share": "Partager"
      }
    },

    "save_draft_button": "Enregistrer en brouillon",
    "update_button": "Modifier la publication",
    "save_and_publish_button": "Publier",

    "confirm_publish_modal_title": "Publier maintenant",
    "confirm_publish_modal_cancel_button": "Annuler",
    "confirm_publish_modal_confirm_button": "Valider",
    "confirm_publish_modal_waiting_message": "Nous envoyons votre publication, cette action peut prendre quelques secondes..."
  },

  // AVIS ET COMMENTAIRES

  "reviews": {
    "page_title": "@:reviews.main_title - @:common.appname",

    "main_title": "Mes avis et commentaires",

    "middleware_message": {
      "default": "Votre établissement ne peux pas voir ses avis et y répondre",
      "unvalidated_establishment": "Vous serez contacté par mail pour valider votre paiement et activer votre établissement. Si besoin, n’hésitez pas à contacter l’équipe support via le chat en bas à droite de l’écran",
      "unauthorized_access": "Votre établissement n'a pas les droits pour voir ses avis et y répondre"
    },

    "freemium_message": "Oups ! Pour centraliser et répondre à vos avis Google et TripAdvisor, découvrez nos offres",
    "freemium_button": "Découvrir nos offres",

    "temporary_message_reviews_delay": "Vos avis peuvent mettre jusqu'à 7 jours à arriver jusqu'à nous après vous être connecté à Google ou Facebook",
    "temporary_message_connect": "Vos avis seront accessibles une fois que vous vous serez connecté sur Google ou Facebook",

    "tab_title_no_response": "Sans réponse",
    "tab_title_responded": "Répondu",

    "new_response_success_message": "Votre réponse a bien été envoyée !",
    "edit_response_sucess_message": "Votre réponse a bien été modifiée !",

    "no_response_empty_title": "Vous n'avez pas de nouveaux avis",
    "no_response_empty_description": "Aucun avis n'a été posté dernièrement, ou aucun avis ne correspond à vos critères de recherche",

    "responded_empty_title": "Vous n'avez répondu à aucun avis",
    "responded_empty_description": "Répondre aux avis Google et aux commentaires Facebook est primordial pour votre référencement et pour votre relation avec vos clients",

    "empty_selected": "Sélectionnez un avis",

    // Uniquement l'affichage d'un avis et de la réponse à un avis sur mobile (différent sur pc)
    "mobile_response": {
      "answer_to": "Répondre à {name}",
      "mark_as_unread": "Passer en non lu",
      "answer_title": "Votre réponse",
      "answer_placeholder": "Rédigez votre réponse ici",
      "send_answer_button": "J’envoie",
      "no_answer_tripadvisor": "Répondez à cet avis directement sur Trip Advisor",
      "answer_link_button": "Je réponds à l‘avis"
    },

    "filters": {
      "title": "Mes filtres",
      "platforms_title": "Par plateformes",
      "notes_title": "Par notes",
      "unread_only": "Afficher seulement les non lus"
    }
  },

  // ANALYSE FREEMIUM

  "analyse": {
    "page_title": "@:analyse.main_title - @:common.appname",

    "main_title": "@:menu.app.analyse",

    "middleware_message": "Votre établissement {name} ne peut pas générer d'analyse de présence en ligne car vous êtes sur un compte payant",

    "analyse_button": "Lancer l'analyse",
    "analyse_button_tooltip": "Vous ne pouvez pas lancer d'analyse plus d'une fois par jour",

    "empty_title": "Vous n'avez pas encore lancé d'analyse",
    "empty_description": "L'analyse ne dure que quelques secondes et vous permet d'évaluer votre présence en ligne sur vos plateformes principales : Google, Facebook et votre Office de Tourisme",

    "loading": {
      "main_title": "@:onboarding/analyse.loading.main_title",
      "description": "@:onboarding/analyse.loading.description"
    },

    "solution_message": "Uniformisez vos données sur chaque plateforme",
    "premium_button": "J'améliore mon score avec Uska",
    "last_report": "Dernière analyse le {date}",

    "empty_value": "Aucune information",

    // Reprise du wording du score et des modales de l’onboarding
    "results": {
      "channels_title": "@:onboarding/analyse.results.channels_title",
      "channels_modal_title": "@:onboarding/analyse.results.channels_modal_title",
      "channels_modal_description": "@:onboarding/analyse.results.channels_modal_description",
      "informations_title": "@:onboarding/analyse.results.informations_title",
      "informations_modal_title": "@:onboarding/analyse.results.informations_modal_title",
      "informations_modal_description": "@:onboarding/analyse.results.informations_modal_description"
    },

    "not_found_plateforms": {
      "channels_title": "Vos plateformes non trouvées",
      "channels_modal_title": "Nous n'avons pas trouvé votre établissement",
      "channels_modal_description": "Il se peut que votre établissement n'existe pas sur certaines plateformes, ou que votre fiche ne soit pas encore disponible si vous venez de la créer."
    },

    "premium_card_title": "Et si vous diffusiez vos informations sur 50 plateformes ?"
  },

  // CONVERT FREEMIUM

  "freemium/convert": {
    "page_title": "@:freemium/convert.main_title - @:common.appname",

    "main_title": "Offre Uska {offer} - Allons plus loin dans votre référencement !",
    "subtitle": "Choisissez quand vous souhaitez être contacté",

    "choice_premium_contact": {
      "validation_button": "Je continue",
      "proposals": {
        "meeting": {
          "title": "Je prends rendez-vous avec un conseiller",
          "description": "Vous savez quand vous pouvez être disponible ? Planifiez dès maintenant un appel avec un de nos conseillers."
        },
        "contact": {
          "title": "Je souhaite être recontacté plus tard",
          "description": "Difficile de planifier une date pour un rendez-vous ? On vous rappelle au plus vite !"
        }
      }
    }
  },

  "freemium/comparison": {
    "page_title": "@:freemium/comparison.main_title - @:common.appname",

    "main_title": "Découvrez nos offres",

    "subtitle": "Transformez des recherches Google en nouveaux clients !",

    "offers": {
      "ESSENTIAL": {
        "title": "Essentielle",
        "list": {
          "1": {
            "title": "Accompagnement pour <span>atteindre la clientèle ciblée</span>",
            "icon": "IconUser"
          },
          "2": {
            "title": "Mise à jour en un clic de <span>+50 plateformes</span> (partenaire Apidae)",
            "icon": "IconDeviceMobile"
          },
          "3": {
            "title": "Statistiques quotidiennes",
            "icon": "IconChartBar"
          },
          "4": {
            "title": "",
            "icon": ""
          },
          "5": {
            "title": "",
            "icon": ""
          }
        },
        "price": "39€",
        "complement": "2 mois offerts si paiement annuel soit 390€HT/an (à mettre en petit en dessous)",
        "color": "blue",
        "button": "Je choisis cette offre"
      },
      "PREMIUM": {
        "title": "Premium",
        "list": {
          "1": {
            "title": "Accompagnement pour <span>atteindre la clientèle ciblée</span>",
            "icon": "IconUser"
          },
          "2": {
            "title": "Mise à jour en un clic de <span>+50 plateformes</span> (partenaire Apidae)",
            "icon": "IconDeviceMobile"
          },
          "3": {
            "title": "Réponse facilitée aux <span>avis clients</span>",
            "icon": "IconChatAlt2"
          },
          "4": {
            "title": "<span>Publications</span> sur les réseaux sociaux",
            "icon": "IconShare"
          },
          "5": {
            "title": "Statistiques quotidiennes",
            "icon": "IconChartBar"
          }
        },
        "price": "79€",
        "complement": "2 mois offerts si paiement annuel soit 790€HT/an (à mettre en petit en dessous du prix)",
        "color": "orange",
        "button": "Je choisis cette offre"
      }
    }
  },

  // Ecran avec un formulaire de contact pour passer premium (choix être recontacté)
  "freemium/contact-convert": {
    "page_title": "@:freemium/convert.main_title - @:common.appname",

    "main_title": "Être recontacté par un conseiller Uska",

    "submit_button": "Valider mes informations",

    "validation_title": "Votre demande de contact a bien été envoyée",
    "validation_description": "Nous avons bien reçu votre demande d’aide. Nous vous contacterons dans les plus brefs délais pour faire le point sur vos questions"
  },

  "freemium/contact": {
    "page_title": "@:freemium/contact.main_title - @:common.appname",

    "main_title": "Un problème ? Contactez-nous",

    "submit_button": "@:freemium/contact-convert.submit_button",

    "validation_title": "@:freemium/contact-convert.validation_title",
    "validation_description": "@:freemium/contact-convert.validation_description"
  },

  "freemium/meeting": {
    "page_title": "@:freemium/meeting.main_title - @:common.appname",

    "main_title": "Prendre rendez-vous avec un conseiller Uska",

    "success_title": "Votre rendez-vous est confirmé",
    "success_description": "Vous avez reçu une confirmation de votre rendez-vous par e-mail"
  },

  // SOLICITATIONS

  "solicitations": {
    "page_title": "@:solicitations.main_title - @:common.appname",

    "main_title": "@:menu.app.solicitations",

    "middleware_message": "Votre établissement {name} n'a pas accès aux sollicitations de l'Office de Tourisme",

    "current_tab_title": "En cours",
    "current_tab_empty_message": "Vous n'avez aucune sollicitation en cours",

    "archived_tab_title": "Passées",
    "archived_tab_empty_message": "Vous n'avez aucune sollicitation passée",
    "archived_tab_message": "Toutes les sollicitations de vos plateformes locales sont supprimées au bout de neuf mois."
  },

  // ETABLISSEMENT

  "establishments": {
    "main_title": "Mes établissements",
    "add_establishment_button": "J’ajoute un établissement"
  },

  "establishment/new": {
    "page_title": "Ajout d'établissement - @:common.appname",

    "main_title": "Ajouter un ou plusieurs établissement(s)",

    "choice_freemium_or_premium": {
      "freemium_choice_title": "Ajoutez un nouvel établissement avec les fonctionnalités gratuites",
      "freemium_choice_description": "Vous pouvez ajouter tous vos établissements référencés chez votre Office de Tourisme sur votre compte gratuit",
      "freemium_choice_button": "Ajouter un établissement",

      "premium_choice_title": "Ajoutez un nouvel établissement avec les fonctionnalités premium",
      "premium_choice_description": "Ajoutez votre établissement en version premium et commencez à améliorer votre visibilité en ligne",
      "premium_choice_button": "Ajouter un établissement premium"
    },

    "offer_presentation": {
      "title": "Vous êtes sur le point de vous créer un nouvel établissement",
      "price": "79€",
      "per_month": "/mois",
      "description": "Abonnement premium supplémentaire",
      "button": "Continuer"
    },

    "subtitle": "Choisissez les établissements que vous souhaitez ajouter à votre compte :",

    "add_button": "Ajouter",

    "empty_message": "Vous avez ajouté tous vos établissements connus de votre Office de Tourisme sur Uska !",

    "create_establishment_loading_modal_title": "Nous créons vos établissements...",
    "create_establishment_loading_modal_title_success": "Vos établissements ont bien été créés",
    "create_establishment_loading_modal_description": "Vos nouveaux établissements sont désormais créés ! Vous pouvez maintenant mettre à jour vos établissements sur l'onglet \"Mes informations\" après avoir sélectionné l'établissement de votre choix.",
    "create_establishment_loading_modal_button": "Revenir au tableau de bord"
  },

  "establishment/new/form": {
    "page_title": "Ajout d'établissement - @:common.appname",

    "main_title": "Ajouter un ou plusieurs établissement(s)",

    "establishment_form": {
      "subtitle": "Quel établissement souhaitez-vous ajouter ?",
      "description": "Renseignez simplement le nom de votre établissement et sa commune. Nous nous chargeons du reste !",
      "validation_button": "Je valide"
    },

    "establishment_address_form_validation": {
      "subtitle": "Adresse postale",
      "show_analyse_results_button": "Créer"
    },

    "create_establishment_loading_modal_title": "Bravo ! Demande de création d’établissement validée",
    "create_establishment_loading_modal_title_success": "Vos établissements ont bien été créés",
    "create_establishment_loading_modal_description": "Votre nouvel établissement est désormais créé et en attente de paiement ! Nous vous contacterons pour l’activer dans les plus brefs délais. En attendant, retrouvez-le dans \"Mes abonnements\"",
    "create_establishment_loading_modal_button": "Revenir au tableau de bord"
  },

  "establishments/formulaire": {
    "page_title": "@:menu.app.establishments - @:common.appname",

    "main_title": "Mes informations",

    // S'affiche quand le formulaire ouvert a été envoyé
    "premium_card_title": "Et si vous diffusiez vos informations sur +50 plateformes ?",
    "form_sent_success": "Ce formulaire sera de nouveau disponible après validation de votre Office de Tourisme.",

    "middleware_message": {
      "default": "Votre établissement ne peux pas mettre à jour ses informations",
      "unvalidated_establishment": "Vous serez contacté par mail pour valider votre paiement et activer votre établissement. Si besoin, n’hésitez pas à contacter l’équipe support via le chat en bas à droite de l’écran"
    },

    "user_already_answered": "Vous avez déjà répondu à une sollicitation de votre OT. Pour renvoyer des modifications, veuillez attendre que votre Office valide votre réponse.",
    "user_already_answered_button": "Voir mes sollicitations",

    "no_iframe": "Une erreur est survenue lors de la récupération du formulaire. Contactez-nous via le formulaire dans votre menu en haut à gauche",

    "listing_button": "Mes plateformes",
    "save_button_bar": "J’enregistre",
    "synchronize_button": "Publier maintenant",

    // Modale de confirmation quand on change d'onglet sans enregistrer les modifications en cours
    "confirm_switch_tab_title": "Vous n'avez pas sauvegardé vos modifications",
    "confirm_switch_tab_description": "Vous vous apprêtez à quitter l'onglet sans enregistrer vos modifications.",
    "confirm_switch_tab_save": "Enregistrer et continuer",
    "confirm_switch_tab_no_save": "Continuer sans enregistrer",

    // Modale de confirmation quand on change de page sans enregistrer le smodifications en cours
    "confirm_change_page_title": "Avez vous bien enregistré vos modifications ?",
    "confirm_change_page_description": "Pour sauvegarder vos modifications, rendez vous tout en bas de la page",
    "confirm_change_page_confirm": "Oui, je quitte la page",
    "confirm_change_page_cancel": "Non, je reste",

    // Modale de confirmation pour lancer la mise à jour
    "sync_validate_title": "Confirmez la mise à jour de vos informations",
    "sync_validate_message": "Une fois la mise à jour lancée, l’ensemble des informations de votre profil établissement seront transmises à vos plateformes. Vous ne pourrez pas annuler cette action.",
    "sync_validate_button": "Je confirme la mise à jour",

    // Modale de confirmation du lancement de la mise à jour
    "sync_success_message": "Nous avons bien lancé la mise à jour de vos informations. Celles-ci peuvent mettre quelques jours à apparaître. Pour vérifier l'état de mise à jour, rendez-vous sur votre page “Mes plateformes”.",

    // Modale d'erreur du lancement de la mise à jour
    "sync_error_message": "La publication des vos nouvelles informations a bien été prise en compte.\nNous avons détecté un point de blocage chez l'un de nos partenaires.\nNotre équipe reviendra vers vous pour finaliser la publication.",
    "sync_not_admin": "La publication des vos nouvelles informations a bien été prise en compte.\nIl semblerait que vous ne soyez plus administrateur ou propriétaire de votre page Google my Business.\nNotre équipe reviendra vers vous pour rétablir la configuration de votre compte.",

    // Pas d'établissement dans l'url
    "no_establishment_founded": "Aucun établissement trouvé",

    "generic_informations": {
      "tab_title": "Informations générales",
      "success_alert_message": "Les modifications ont bien été enregistrées. Pensez à les publier !",
      "error_form": "@:common.errors.form",

      "missing_data_message": "Complétez votre profil en ajoutant les informations suivantes : ",

      "edit_location": "Modifier l'emplacement",
      "save_location": "Enregistrer l'emplacement",

      "establishment_name": {
        "label": "@:common.form.establishment_name.label",
        "placeholder": "@:common.form.establishment_name.placeholder"
      },

      "city": {
        "label": "@:common.form.city.label",
        "no_options_text": "@:common.form.city.no_options_text",
        "no_results_text": "@:common.form.city.no_results_text",
        "placeholder": "@:common.form.city.placeholder"
      },

      "country": {
        "label": "@:common.form.country.label",
        "no_options_text": "@:common.form.country.no_options_text",
        "no_results_text": "@:common.form.country.no_results_text",
        "placeholder": "@:common.form.country.placeholder"
      },

      "address": {
        "label": "@:common.form.address.label",
        "placeholder": "@:common.form.address.placeholder"
      },

      "additional_address": {
        "label": "Complément d'adresse",
        "placeholder": ""
      },

      "postal_code": {
        "label": "@:common.form.postal_code.label",
        "placeholder": "@:common.form.postal_code.placeholder"
      },

      "siret": {
        "label": "Numéro d'Identification Légale (SIRET)",
        "placeholder": ""
      },

      "establishment_main_category": {
        "label": "Catégorie principale",
        "no_options_text": "Recherchez une catégorie (au moins 3 lettres)",
        "no_results_text": "Aucun résultat",
        "placeholder": "ex: Gîte",
        "tooltip_description": "La catégorie principale de votre établissement représente votre cœur de métier. C'est celle qui va définir et adapter les autres champs du formulaire."
      },

      "establishment_categories": {
        "label": "Catégories secondaires",
        "no_options_text": "Recherchez 'une catégorie (au moins 3 lettres)",
        "no_results_text": "Aucun résultat",
        "placeholder": "ex: Restaurant",
        "tooltip_description": "Les catégories secondaires permettent à Google de mieux vous référencer, et d'avoir une meilleure visibilité"
      },

      "long_description": {
        "label": "Description longue",
        "placeholder": "Ajoutez ici une description détaillée de votre activité",
        "tooltip_description": "Décrivez votre établissement, votre histoire et ce qui vous rend unique. Précisez également les services que vous proposez.",
        "special_rules": {
          "GOOGLE": "priorise la description longue si elle fait moins de 700 caractères",
          "FACEBOOK": "priorise la description longue si elle fait moins de 255 caractères"
        }
      },

      "name": {
        "special_rules": {
          "FACEBOOK": "ne nous autorise pas à modifier le nom de votre Page"
        }
      },

      "keywords": {
        "label": "Mots clés",
        "tooltip_description": ""
      },

      "short_description": {
        "label": "Description courte",
        "placeholder": "Ajoutez ici une brève description de votre activité",
        "tooltip_description": "Décrivez brièvement votre établissement et les services proposés"
      }
    },

    "specific_informations": {
      "tab_title": "Informations spécifiques",
      "success_alert_message": "Les modifications ont été prises en compte",

      "missing_data_message": "Complétez votre profil en ajoutant les informations suivantes : ",

      // Erreur affichée sur le formulaire si aucune catégorie principale n'a été sélectionné
      "error_no_main_category": {
        "title": "Veuillez sélectionner une catégorie principale",
        "description": "Vous ne pouvez pas modifier vos informations tant que vous n'avez pas sélectionné votre catégorie principale dans l'onglet Informations générales"
      },

      "attributes": {
        "label": "Caractéristiques",
        "tooltip_description": "Les caractéristiques vous permettent de préciser les produits ou services disponibles (ou indisponibles) dans votre établissement. Plus vous fournissez d'informations, mieux vos clients vous connaîtront. Les caractéristiques varient en fonction de la catégorie principale de votre établissement.",
        "new_button": "Nouvelle caractéristique",

        // Modal d'ajout d'attribut
        "new_modal_title": "Sélectionnez des caractéristiques",
        "no_options_text": "Recherchez une caractéristique",
        "no_results_text": "Aucun résultat",
        "placeholder": "Recherchez une caractéristique",
        "validate_all_button": "Ajouter"
      },

      "payments_options": {
        "label": "Moyens de paiement",
        "tooltip_description": "Aidez vos clients à préparer leur visite dans votre établissement, et indiquez les moyens de paiement disponibles (ou indisponibles) dans votre établissement",
        "new_button": "Nouveau moyen de paiement",

        // Modal d'ajout de moyen de paiement
        "new_modal_title": "Sélectionnez des moyens de paiement",
        "no_options_text": "Recherchez un moyen de paiement",
        "no_results_text": "Aucun résultat",
        "placeholder": "Recherchez un moyen de paiement",
        "validate_all_button": "Ajouter"
      },

      "languages": {
        "label": "Langues",
        "no_options_text": "Recherchez une langue",
        "no_results_text": "Aucun résultat",
        "placeholder": "ex : Anglais",
        "tooltip_description": "Faites savoir à vos clients dans quelles langues vous pouvez les accueillir"
      },

      "brands": {
        "label": "Marques",
        "tooltip_description": "Vos clients peuvent rechercher des marques et des fabricants spécifiques. Informez-les de ce que votre établissement peut leur offrir !"
      }
    },

    "hours": {
      "tab_title": "Horaires d'ouverture",
      "success_alert_message": "Les modifications ont été prises en compte",

      "missing_data_message": "Complétez votre profil en ajoutant des horaires d'ouverture",

      "OPEN": "Ouvert",
      "CLOSED": "Fermé",

      "open_24_7": "L'établissement est ouvert 24H/24 et 7J/7",
      "add_hour_button": "Ajouter une plage horaire",

      // Horaires exceptionnels
      "exceptionnal_hours_title": "Horaires exceptionnels",
      "add_exceptionnal_hours_button": "Ajouter des horaires",
      "exceptionnal_hours_date_picker_placeholder": "Choisissez une période",
      "exceptionnal_hours_overlap_error": "Attention, il n'est pas possible d'ajouter plusieurs horaires exceptionnels sur une même période. Veuillez modifier les périodes concernées.",
      "add_exceptional_error_first_line": "Vous ne pouvez pas ajouter d'horaires exceptionnels sur ces dates !",
      "add_exceptional_error_second_line": "Vérifiez que votre établissement dispose d’horaires d’ouvertures et n’est pas temporairement fermé ou ouvert 24h/24 sur cette période",

      "conflict_modify_hours_button": "Modifier les horaires",
      "conflict_modify_accept_button": "Enregistrer et supprimer les horaires exceptionnels",

      "exceptional_hours_card": {
        "title": "Ajouter des horaires exceptionnels",
        "examples": {
          "one": "Fermeture lors des jours fériés",
          "two": "Fermeture anticipée pour une durée de 7 jours maximum",
          "three": "Vacances"
        },
        "description": "Afin de s'assurer que les horaires exceptionnels sont publiés à temps sur les plateformes en ligne, veuillez les programmer au moins 7 jours à l'avance. Fermer un établissement pour plus de 7 jours consécutifs pourra être considéré comme “fermé temporairement” par certaines plateformes."
      },

      "exceptional_hours_modal": {
        "title": "Ajouter des horaires exceptionnels"
      },

      "period_hours_title": "Horaires planifiées",
      "add_period_hours_button": "Planifier des horaires",
      "save_period_hours_button": "Enregistrer les horaires",
      "temporary_closed": "L'établissement est fermé temporairement",
      "temporary_closed_alert": "Le statut \"temporairement fermé\" est directement visible sur vos différentes plateformes.",
      "temporary_closed_alert_description": "Si votre réouverture est prévue dans les 7 jours, nous vous invitons à utiliser l'onglet \"Horaires exceptionnels\" pour fermer uniquement les jours concernés de la semaine.",
      "empty_base_hours": "Votre fiche Facebook ne dispose pas d'horaires d'ouvertures. Il s'agit d'une information obligatoire par la plateforme pour pouvoir passer sur une fermeture temporaire, ou sur une ouverture 24/7. Pour celà, merci de renseigner des horaires d'ouvertures sur votre page Facebook.",
      "check_facebook_hours_button": "Voir mes horaires",

      "period_hours_modal": {
        "title": "Planifier un changement d'horaires",
        "edit_title": "Modifier mes horaires planifiés",
        "edit_current_title": "Modifier mes horaires actuels"
      },

      "period_hours_card": {
        "title": "Planifier des horaires",
        "examples": {
          "one": "Changement de saison",
          "two": "Fermeture temporaire",
          "three": "Planning d'horaires déjà établi"
        },
        "description": "Les périodes d'ouvertures sont mises à jour automatiquement et au bon moment par Uska sur vos plateformes"
      }
    },

    "medias": {
      "tab_title": "Contenus photos",
      "description": "Vos photos seront affichées sur toutes les plateformes. Vous pouvez sélectionner une Photo à la Une pour certains albums, qui sera utilisée par défaut si une plateforme n’accepte qu’une seule photo.",

      "missing_data_message": "Ajoutez vos logos et des photos pour compléter votre profil",

      // Indications de taille / format / mode d'images à importer pour chaque albums
      "helper": {
        "title": "Vous pouvez recadrer et ajuster les photos que vous téléchargez",
        "mode": {
          "16:9": "Paysage (16:9)",
          "1:1": "Carré (1:1)"
        },
        "mode_title": "Mode recommandé",
        "format_title": "Format",
        "size_title": "Taille",
        "size_format": "{size}MB",
        "size_min": "(minimum suggéré : 1200x1200)"
      },

      // Photo à la une
      "featured_picture_title": "Photo à la une",
      "featured_picture_description": "La Photo à la Une est celle qui sera utilisée par défaut. Si nous devons utiliser qu'une seule photo pour cet album, il s'agirait de cette photo.",
      "featured_picture_modal_close_button": "Fermer",
      "featured_picture_modal_choose_button": "Choisir comme Photo à la Une",

      // Qualité de la photo
      "bad_quality_description": "La qualité de la photo n'est pas optimale",

      // Bouton d'ajout de média
      "add_image_button_title": "Ajouter une photo",

      // Modal pour crop l'image
      "crop_modal_title": "Ajouter la photo",
      "crop_modal_message": "Votre photo doit être recadrée pour se conformer au format attendu",
      "crop_modal_cancel_button": "Annuler",
      "crop_modal_save_button": "Enregistrer",

      // Liste des albums
      "albums": {
        "LOGO": {
          "title": "Logo",
          "description": "Il s’agit du logo de votre établissement."
        },
        "SQUARED_LOGO": {
          "title": "Logo carré",
          "description": "Il s’agit du logo de votre établissement, au format carré."
        },
        "LANDSCAPE": {
          "title": "Couverture Google",
          "description": "Il s’agit de la photo de couverture qui apparaîtra sur votre page Google"
        },
        "FACEBOOK_LANDSCAPE": {
          "title": "Couverture Facebook",
          "description": "Il s’agit de la photo de couverture qui apparaîtra sur votre page Facebook."
        },
        "EXTERIOR": {
          "title": "Extérieur",
          "description": "Ajoutez des photos de l’extérieur de votre établissement"
        },
        "INTERIOR": {
          "title": "Intérieur",
          "description": "Ajoutez des photos de l’intérieur de votre établissement"
        },
        "FOOD_AND_DRINK": {
          "title": "Nourriture et boissons",
          "description": "Ajoutez des photos des plats et boissons servis dans votre établissement"
        },
        "MENU": {
          "title": "Menu",
          "description": "Ajoutez les menus proposés dans votre établissement"
        },
        "PRODUCT": {
          "title": "Produits",
          "description": "Ajoutez des photos des produits que vous proposez dans votre établissement"
        },
        "TEAMS": {
          "title": "Équipe",
          "description": "Ajoutez des photos de votre équipe"
        },
        "AT_WORK": {
          "title": "Bureaux",
          "description": "Ajoutez des photos des bureaux de votre établissement"
        },
        "COMMON_AREA": {
          "title": "Espace commun",
          "description": "Ajoutez des photos des espaces communs de votre établissement"
        },
        "ROOMS": {
          "title": "Pièces",
          "description": "Ajoutez des photos des pièces de votre établissement"
        },
        "PHOTO": {
          "title": "Photos supplémentaires",
          "description": "Ajoutez ici les photos qui ne rentrent dans aucun album mais que vous souhaitez tout de même diffuser."
        }
      },

      // Erreur affichée sur le formulaire si aucune catégorie principale n'a été sélectionné
      "error_no_main_category": {
        "title": "Veuillez sélectionner une catégorie principale",
        "description": "Vous ne pouvez pas modifier vos informations tant que vous n'avez pas sélectionné votre catégorie principale dans l'onglet Informations générales"
      },

      // Erreur affichée si la liste des albums de l'établissement est vide
      "error_no_album": {
        "title": "Il y a un petit problème...",
        "description": "Nous ne retrouvons pas vos albums... Avez-vous bien ajouté votre catégorie principale ? N’hésitez pas à nous contacter si vous avez besoin d’aide."
      }
    },

    "contact": {
      "tab_title": "Contact",
      "description": "Ce sont les informations de contact qui seront visibles sur vos plateformes digitales",

      "missing_data_message": "Complétez votre profil en ajoutant des moyens de contact",

      "success_alert_message": "Les modifications ont été prises en compte",
      "error_form": "@:common.errors.form",

      "phone": {
        "label": "@:common.form.phone.label principal",
        "placeholder": "@:common.form.phone.placeholder"
      },

      "mobile": {
        "label": "@:common.form.phone.label",
        "placeholder": "@:common.form.phone.placeholder"
      },

      "email": {
        "label": "@:common.form.email.label",
        "placeholder": "@:common.form.email.placeholder"
      }
    },

    "platforms": {
      "tab_title": "Sites et plateformes",
      "tab_description": "Copiez l'url de votre page depuis votre navigateur et collez-la dans les champs ci-dessous",
      "error_form": "@:common.errors.form",

      "missing_data_message": "Complétez votre profil en ajoutant des liens",

      "website": {
        "label": "Site web",
        "placeholder": "@:common.form.url.placeholder"
      },

      "facebook": {
        "placeholder": "https://facebook.com/nom-de-votre-page",
        "error": "Ce champ doit respecter le format d'url de Facebook : https://facebook.com/nom-de-votre-page OU https://www.facebook.com/profile.php?id=votre_identifiant_de_compte"
      },

      "pinterest": {
        "placeholder": "https://pinterest.fr/nom-de-votre-page",
        "error": "Ce champ doit respecter le format d'url de Pinterest : https://pinterest.fr/nom-de-votre-page"
      },

      "tiktok": {
        "placeholder": "https://tiktok.com/nom-de-votre-page",
        "error": "Ce champ doit respecter le format d'url de Tiktok : https://tiktok.com/nom-de-votre-page"
      },

      "linkedin": {
        "placeholder": "https://linkedin.com/in/nom-de-votre-page",
        "error": "Ce champ doit respecter le format d'url de Linkedin : https://linkedin.com/in/nom-de-votre-page ou https://linkedin.com/company/nom-de-votre-page"
      },

      "youtube": {
        "placeholder": "https://youtube.com/nom-de-votre-page",
        "error": "Ce champ doit respecter le format d'url de Youtube : https://youtube.com/{'@'}nom-de-votre-page ou https://youtube.com/channel/identifiant-de-votre-page"
      },

      "instagram": {
        "placeholder": "https://instagram.com/nom-de-votre-page",
        "error": "Ce champ doit respecter le format d'url de Instagram : https://instagram.com/nom-de-votre-page"
      },

      "twitter": {
        "placeholder": "https://x.com/nom-de-votre-page",
        "error": "Ce champ doit respecter le format d'url de X (ex Twitter) : https://x.com/nom-de-votre-page"
      },

      "platforms_title": "Mes plateformes",
      "platforms_tooltip_description": "Ces url sont utilisées pour permettre à vos clients d'accéder facilement à vos réseaux sociaux depuis votre fiche Google."
    }
  },

  "establishments/listing": {
    "page_title": "@:establishments/listing.main_title - @:common.appname",

    "main_title": "Mes plateformes",

    "last_sync_description": "Dernière mise à jour le {date}",

    "legend_description": "Pour chacune de vos plateformes digitales, 3 états de mise à jour sont possibles :",
    "legend_success": "Tout va bien ! Vos informations sont à jour",
    "legend_sync_in_progress": "Vos informations principales sont à jour. Certains champs peuvent nécessité un traitement plus long pour certaines plateformes.",
    "legend_warning": "Vos informations ont été transmises, la mise à jour peut prendre un peu de temps",
    "legend_error": "La transmission ou la mise à jour de vos informations est impossible. Vous devez sûrement effectuer une action pour débloquer la situation.",
    "legend_pause": "Lancez votre première mise à jour pour activer cette plateforme",

    "connect_button": "Je me connecte",
    "logout_button": "Je me déconnecte",
    "success_connexion_message": "@:home.success_connexion_message",
    "is_connected": "Connecté",


    // Titre du statut, qui s’affiche sur la ligne (avec l’icone et la couleur correspondante)
    "states": {
      "WAIT_FOR_SYNC": "En attente",
      "SYNCHRONIZED": "Informations à jour",
      "SUBMITTED": "Mise à jour en cours...",
      "BEING_UPDATED": "Mise à jour en cours...",
      "NO_CONNEXION": "Non connecté",
      "ERROR_CLAIMED_BY_OTHERS": "Non mis à jour",
      "ERROR_CLAIMED_BY_ANOTHER_US": "Non mis à jour",
      "ERROR_FIELDS": "Non mis à jour",
      "ERROR_NOT_CONNECTED": "Non mis à jour",
      "ERROR_NOT_FOUND": "Non mis à jour",
      "ERROR": "Non mis à jour",

      "PENDING_CONNECTION": "Demande de connexion envoyée",
      "CONNECTED": "Demande de connexion validée",
      "REFUSED": "Demande de connexion refusée",
      "IGNORED": "Demande de connexion ignorée",

      // Statut de mise à jour du diffuseur local
      "ANSWERED": "Réponse reçue par votre OT",
      "SENT_APIDAE": "A jour",
      "SENT_TOURINSOFT": "A jour",
      "TREATED": "Réponse traitée par votre OT",
      "DRAFT": "Enregsitré en brouillon",
      "SAVING": "En cours d'enregistrement",
      "SAVING_DRAFT": "En cours d'enregistrement",
      "NO_FORM": "Pas de formulaire ouvert",

      // Erreurs custom
      "SYNC_IN_PROGRESS": "Informations à jour",
      "SYNC_IN_PROGRESS_TOOLTIP": "Certains champs sont encore en cours de mise à jour"
    },

    // Message qui s’affiche en dessous de la plateforme, dans l’encadré de couleur (actuellement, le message ne s’affiche que si c’est une erreur - rouge)
    "errors": {
      // Message si vert (actuellement pas affiché)
      "WAIT_FOR_SYNC": "En attente d’activation",

      // Message si vert (actuellement pas affiché)
      "SYNCHRONIZED": "Mis à jour",

      // Message si orange (actuellement pas affiché)
      "SUBMITTED": "En attente de mise à jour par la plateforme",
      "BEING_UPDATED": "En attente de validation par la plateforme",

      // Messages si rouge
      "ERROR_CLAIMED_BY_OTHERS": "Compte déjà revendiqué par un tiers",
      "ERROR_CLAIMED_BY_ANOTHER_US": "Compte déjà revendiqué par un partenaire",
      "ERROR_FIELDS": "Certains champs obligatoires sont manquants",
      "ERROR_NOT_CONNECTED": "Pas de connexion ou manque d'informations sur les horaires ou les catégories",
      "ERROR_NOT_FOUND": "Une erreur en provenance de Google ou Facebook est survenue",
      "ERROR": "Une erreur est survenue",

      // Erreurs spécifiques google (supérieures aux erreurs génériques)
      "GOOGLE_NOT_CONNECTED": "Non connecté",
      "GOOGLE_NOT_FOUND": "Pas de page trouvée",
      "GOOGLE_NOT_VERIFIED": "Pas de page vérifiée",
      "GOOGLE_IN_VERIFICATION": "Page en cours de vérification",
      "GOOGLE_NOT_CONNECTED_VERIFIED": "Non connecté. Demandez les droits à l'administrateur ou connectez-vous avec un autre compte",
      "GOOGLE_ERROR": "Une erreur est survenue",

      // Erreurs spécifiques facebook (supérieures aux erreurs génériques)
      "FACEBOOK_NOT_CONNECTED": "Non connecté",
      "FACEBOOK_NOT_FOUND": "Pas de page trouvée",
      "FACEBOOK_FOUNDED": "Page trouvée",
      "FACEBOOK_ERROR": "Une erreur est survenue",

      // Erreurs spécifiques à Insta (en attendant la connexion via api)
      "insta_waiting_message": "Encore un peu de patience... Instagram arrive bientôt sur Uska !"
    },

    "local_diffusers_title": "Mes plateformes locales",

    "main_diffusers_title": "Mes plateformes principales",
    "main_diffusers_legend": "Vos principales plateformes digitales sont les plus importantes pour votre visibilité en ligne. Ce sont celles que vos clients et futurs clients vont consulter.",

    "secondary_diffusers_title": "Mes plateformes secondaires",
    "secondary_diffusers_legend": "Vos plateformes digitales secondaires sont également mises à jour avec vos informations. Votre présence sur ces plateformes permet d’améliorer grandement le référencement de vos plateformes principales, et notamment de votre fiche Google, par rapport à celles de vos concurrents.",

    "others_diffusers_title": "Nos autres plateformes",

    "empty_list": "Nous n'avons pas pu récupérer vos plateformes digitales et leurs statuts de mise à jour",

    "premium_modal_title": "Vous souhaitez mettre à jour vos informations avec {diffuser} ?",
    "premium_modal_description": "Pour accéder aux autres plateformes que nous proposons, vous devez être membre premium. Être membre premium, c'est aussi profiter d'un accompagnement plus régulier et de fonctionnalités supplémentaires !",

    "contact_title": "Vous souhaitez ajouter une nouvelle plateforme ?",
    "contact_send_button": "Envoyer ma proposition",
    "message": {
      "label": "",
      "placeholder": "Ecrivez ici le nom de la plateforme que vous ne trouvez pas"
    }
  },

  // AUTHENTIFICATIONS

  "authentication": {
    "google_button": "Me connecter avec Google",
    "mail_button": "Me connecter avec mon email",

    "connexion_form": {
      "main_title": "Connexion",
      "main_description": "Connectez-vous pour prendre en main votre présence en ligne",
      "forget_password_link": "J'ai oublié mon mot de passe",
      "validation_button": "Je me connecte",

      // Erreurs de connexion
      "error_email_not_verified": "Vous n'avez pas encore validé votre adresse e-mail, vous ne pouvez pas vous connecter",
      "error_wrong_email_or_password": "Votre adresse e-mail ou votre mot de passe est incorrect",

      // Création de compte
      "new_on_app": "Nouveau sur @:common.appname ?",
      "create_account_link": "Je contacte l'équipe"
    }
  },

  "authentication/contact": {
    "contact_form": {
      "main_title": "Nous contacter",
      "subtitle": "Un conseiller vous rappellera dans les plus brefs délais",
      "description": "Merci de préciser votre besoin afin que l'on puisse répondre le plus efficacement à votre demande"
    }
  },

  "firstconnexion": {
    "create_password_form": {
      "main_title": "Créez votre mot de passe",
      "description": "Pour votre première connexion, créez un mot de passe sécurisé",
      "vaidation_button": "Je valide"
    },

    // Si le lien / token n'est pas bon
    "error": {
      "title": "OOps ! Une erreur est survenue",
      "description": "Votre lien ne fonctionne pas"
    }
  },

  "authentication/resetpassword/email": {
    "email_form": {
      "title": "Je réinitialise mon mot de passe",
      "description": "Pour cela, vous devez nous confirmer l’e-mail que vous utilisez pour vous connecter",
      "email_sent_success_message": "Un e-mail a été envoyé à l'adresse {mail}",
      "send_email_button": "M’envoyer un e-mail"
    }
  },

  "authentication/resetpassword/validation": {
    "reset_password_form": {
      "main_title": "Je réinitialise mon mot de passe",
      "description": "Je saisis mon nouveau mot de passe",
      "validation_button": "Je valide mon mot de passe"
    },
    "error": {
      "title": "OOps ! Une erreur est survenue",
      "description": "Votre lien n'est pas ou plus valide. <br/>Vérifiez vos derniers e-mails ou faites une nouvelle demande de réinitialisation.",
      "token_expired": "Le lien de validation n'existe plus"
    }
  },

  "unsubscribe": {
    "title": "Se désabonner",
    "description": "Vous souhaitez désabonner cette adresse e-mail ? Vous ne recevrez plus aucun e-mails de Uska",
    "unsubscribe_button": "Oui, je me désabonne",
    "cancel_button": "Non, je reste abonné",

    "error": {
      "title": "Une erreur est survenue",
      "description": "Nous avons des difficultés à retrouver votre compte"
    },
    "success": {
      "title": "Vous êtes désabonné",
      "description": "Vous ne recevrez plus de mails Uska sur cette adresse email",
      "button": "Aller sur Uska"
    },
    "already_unsubscribed": {
      "title": "Vous êtes déjà désabonné",
      "description": "Vous ne recevez plus de mails Uska sur cette adresse email",
      "button": "Aller sur Uska"
    }
  },

  "inscription": {
    "google_button": "Créer un compte avec Google",
    "mail_button": "Créer un compte avec mon email",

    "premium_inscription_form": {
      "main_title": "Créer mon compte",
      "description": "Créez votre compte pour prendre en main votre présence en ligne",
      "mention": "",
      "button": "Je crée mon compte"
    },
    "freemium_inscription_form": {
      "main_title": "Créer mon compte",
      "description": "Créez votre compte offert par votre OT pour accéder à votre espace",
      "mention": "Aucune carte bancaire requise",
      "button": "Je crée mon compte"
    },
    "validation_email": {
      "title": "Je valide mon adresse e-mail",
      "we_sent_email_at": "Nous avons envoyé un e-mail à",
      "description": "Cliquez sur le lien reçu par mail pour confirmer votre adresse e-mail. Une fois l'e-mail validé, vous pouvez vous connecter.",
      "connexion_button": "Je me connecte"
    }
  },

  "inscription/contact": {
    "inscription_form": {
      "main_title": "Créer mon compte",
      "description": "Nous vous recontacterons pour vous aider à créer votre compte"
    },
    "validation_title": "Votre demande de contact a bien été envoyée",
    "validation_description": "Nous avons bien pris en compte votre demande de création de compte Uska. Nous vous contacterons dans les plus brefs délais"
  },

  "inscription/validation": {
    "email_validated": {
      "main_title": "Votre e-mail a été validé !",

      // Phrase composée, avec un lien cliquable sur description_connexion_link
      "description_part1": "Vous pouvez désormais",
      "description_connexion_link": "vous connecter",
      "description_part2": "à votre compte @:common.appname"
    },
    "error": {
      "title": "OOps ! Une erreur est survenue"
    }
  },

  // ONBOARDING

  "onboarding/introduction": {
    "information_panel": {
      "main_title": "Bienvenue !",
      "subtitle": "Qu’est-ce que Uska ? ",
      "description": "L’outil qui simplifie la présence en ligne des pros du tourisme :",
      "list": {
        "first": "Maintenez à jour vos informations en 1 clic",
        "second": "Créez simplement des publications sur vos réseaux",
        "third": "Répondez facilement à tous vos avis clients"
      }
    },
    "introduction_presentation": {
      "main_title": "Pour commencer…",
      "subtitle": "Effectuons une analyse complète de votre présence en ligne",
      "action_button": "C’est parti !",
      "list": {
        "first": {
          "title": "En un clin d’oeil",
          "description": "L'analyse de votre présence en ligne se fait en 3 étapes, et ne prend que 3 minutes !"
        },
        "second": {
          "title": "Aucun engagement",
          "description": "Pas besoin de vous créer un compte pour avoir accès à vos résultats. Vous les obtenez directement après l'analyse."
        },
        "third": {
          "title": "Gratuit",
          "description": "Cette analyse est 100% gratuite, et vous permettra d’identifier facilement vos axes d’amélioration. Alors, on y va ?"
        }
      },
      "not_first_time_modal": {
        "title": "Vous êtes déjà passé par là !",
        "description": "Souhaitez-vous poursuivre avec {name} ?",
        "restart_button": "Je recommence",
        "resume_button": "Je reprends"
      }
    }
  },

  "onboarding/freemium": {
    "free": {
      "title": "Gratuit",
      "button": "Créer mon compte gratuit",
      "description": "Découvrez votre nouvel espace pro",
      "features": [
        "Mettez à jour vos informations pour votre OT",
        "Analysez votre présence en ligne",
        "Retrouvez vos sollicitations"
      ]
    },

    "premium": {
      "title": "Premium",
      "button": "Créer mon compte premium",
      "description": "Découvrez la version Premium d’Uska pour booster votre visibilité",
      "features": [
        "Mettez à jour vos informations sur 50 plateformes",
        "Publiez sur Google et Facebook",
        "Répondez à vos avis"
      ]
    }
  },

  "onboarding/begin": {
    "information_panel": {
      "main_title": "Votre établissement",
      "subtitle": "Renseignez vos informations",
      "description": "Attention aux fautes de frappe. Aidez-nous en renseignant le nom complet de votre établissement."
    },
    "establishment_form": {
      "main_title": "Choix de l’établissement",
      "subtitle": "Quel établissement souhaitez-vous analyser ?",
      "description": "Renseignez simplement le nom de votre établissement et sa commune. Nous nous chargeons du reste !",
      "input_label_establishment_name": "Nom de l'établissement",
      "establishment_name_error": "Veuillez saisir le nom de votre établissement",
      "validation_button": "Je valide"
    },
    "establishment_address_form_validation": {
      "main_title": "Vérifiez votre adresse",
      "address_label": "Votre établissement",
      "show_analyse_results_button": "J’accède à mes résultats"
    }
  },

  "onboarding/establishment": {
    "information_panel": {
      "main_title": "Informations requises",
      "subtitle": "Je renseigne mes informations",
      "description": "Nous vous invitons à choisir l'établissement pour lequel vous souhaitez lancer l'analyse"
    },
    "establishment_list_choice": {
      "main_title": "Quel établissement souhaitez-vous analyser ?",
      "action_button": "Je consulte les résultats"
    },
    "one_establishment_validation": {
      "main_title": "C'est bien vous ?",
      "action_button": "@:onboarding/establishment.establishment_list_choice.action_button",
      "no_address_founded_message": "Pas d'adresse trouvée",
      "reject_button": "Non, ce n'est pas mon établissement"
    }
  },

  "onboarding/analyse": {
    "main_title": "Mon analyse",

    "loading": {
      "main_title": "Analyse en cours...",
      "description": "Servez-vous un café, nous prenons une minute pour trouver vos informations en ligne et effectuer votre analyse"
    },
    "information_panel": {
      "main_title": "Résultats de l'analyse",
      "score_title_under_percent_50": "Vous pouvez progresser !",
      "score_title_under_percent_75": "Encore un petit effort !",
      "score_title_under_percent_100": "Presque au top !",
      "score_title_at_100": "Bravo, vos informations sont cohérentes !"
    },
    "results": {
      "channels_title": "Vos plateformes analysées",
      "channels_modal_title": "Pourquoi analyser vos informations sur ces pages ?",
      "channels_modal_description": "Nous analysons les plateformes les plus importantes pour votre visibilité : Google, Facebook et votre Office de Tourisme.",
      "informations_title": "Informations sur votre établissement",
      "informations_modal_title": "Comment améliorer la qualité de mes informations ?",
      "informations_modal_description": "Vos informations principales doivent être renseignées sur chaque plateforme, et identique d’une plateforme à une autre. Avoir des informations complètes et identiques sur chaque plateforme joue un rôle déterminant dans votre référencement sur internet. Prenez donc le temps d’uniformiser vos informations !",
      "informations_line_appreciation": {
        "difference_founded": "Différence trouvée",
        "not_found": "Non renseigné",
        "everything_ok": "Aucune erreur détectée"
      },
      "informations_line_title": {
        "name": "Nom",
        "address": "Adresse",
        "access": "Accès",
        "additional_address": "Complément d'adresse",
        "latitude": "Latitude",
        "longitude": "Longitude",
        "postal_code": "Code postal",
        "city": "Commune",
        "phone": "Téléphone",
        "website": "Site Web",
        "opening_hours": "Horaires d'ouverture",
        "medias": "Images"
      }
    }
  },

  "onboarding/howtocreatemyaccount": {
    "information_panel": {
      "main_title": "Je crée mon compte",
      "subtitle": "Comment prendre en main votre présence en ligne ?",
      "description": "Créez votre compte et profitez des :",
      "list": {
        "first": "Mises à jour de vos informations centralisées",
        "second": "Publications sur vos réseaux",
        "third": "Gestion de tous vos avis clients"
      }
    },
    "choice_how_to_create_account": {
      "validation_button": "Je continue",
      "proposals": {
        "autonomy": {
          "title": "Je crée mon compte en autonomie",
          "description": "À partir d'une adresse e-mail ou d'un compte Google, créez votre compte en autonomie en seulement 10 minutes"
        },
        "need_help": {
          "title": "Être accompagné dans la création de mon compte",
          "description": "Un conseiller vous rappellera dans les plus brefs délais pour vous guider dans la création de votre compte"
        }
      }
    }
  },

  "onboarding/contactus": {
    "information_panel": {
      "main_title": "Besoin d'être rappelé par un conseiller ?",
      "description": "Échangez 30 minutes avec l’un de nos conseillers, afin de mieux comprendre comment gérer votre présence en ligne",
      "subtitle": "En discutant avec l'un de nos conseillers, vous pourrez :",
      "list": {
        "first": "Avoir des réponses à vos questions",
        "second": "Faire le point sur votre présence en ligne",
        "third": "Être accompagné dans la création de votre compte"
      }
    },
    "contact_form": {
      "main_title": "Laissez vos coordonnées",
      "subtitle": "Un conseiller vous rappellera dans les plus brefs délais",
      "description": "Plus vous nous en dites sur la raison de votre prise de contact, plus nous serons efficaces 😃"
    }
  },

  "onboarding/contactus/howtocreatemyaccount": {
    "information_panel": {
      "main_title": "Besoin d'être rappelé par un conseiller ?",
      "description": "Échangez 30 minutes avec l’un de nos conseillers, afin de mieux comprendre comment gérer votre présence en ligne",
      "subtitle": "En discutant avec l'un de nos conseillers, vous pourrez :",
      "list": {
        "first": "Avoir des réponses à vos questions",
        "second": "Faire le point sur votre présence en ligne",
        "third": "Être accompagné dans la création de votre compte"
      }
    },
    "contact_form": {
      "main_title": "Laissez vos coordonnées",
      "subtitle": "Faites vous aider par un conseiller pour créer votre compte",
      "description": "Un conseiller vous contactera dans les plus brefs délais ! N'hésitez pas à nous donner vos disponibilités 😉"
    }
  },

  "onboarding/contactus/errorloadingestablishment": {
    "information_panel": {
      "main_title": "Nous n'avons pas trouvé votre établissement",
      "description": "Aidez-nous en renseignant le nom exact de votre établissement. Un tiret, un accent, un espace ou une abréviation peuvent faire la différence.",
      "subtitle": "Les différentes causes possibles",
      "list": {
        "first": "Un ou plusieurs établissements possèdent le même nom ou un nom très similaire au vôtre",
        "second": "Nous manquons d'informations pour identifier s’il s’agit bien votre établissement",
        "third": "Vous avez fait une légère faute d'orthographe dans le nom de l'établissement ou dans le code postal",
        "fourth": "Vous n'êtes pas référencé sur Google, Facebook et Tripadvisor"
      }
    },
    "contact_form": {
      "main_title": "Laisser mes coordonnées",
      "subtitle": "Détecter votre présence en ligne n’est pas simple",
      "description": "Donnez-nous plus d’informations sur votre établissement et nous vous rappellerons dans les plus bref délais !"
    }
  },

  "onboarding/contactus/errorwrongestablishment": {
    "information_panel": {
      "main_title": "Ce n'est pas votre établissement ?",
      "description": "Faites attention à renseigner le nom exact de votre établissement. Un tiret, un accent, un espace ou une abréviation peuvent faire la différence...",
      "subtitle": "Les différentes causes possibles",
      "list": {
        "first": "Un ou plusieurs établissements possèdent le même nom ou un nom très similaire au votre",
        "second": "Nous manquons d'informations afin d’identifier s’il s’agit bien votre établissement",
        "third": "Vous avez fait une légère faute d'orthographe dans le nom de l'établissement ou dans le code postal"
      }
    },
    "contact_form": {
      "main_title": "Laissez vos coordonnées",
      "subtitle": "On vous rappellera dans les plus brefs délais !",
      "description": "Visiblement, tout ne se passe pas comme prévu... Faites directement le point sur votre présence en ligne avec un de nos conseillers."
    }
  },

  "onboarding/contactend": {
    "main_title": "Merci pour votre message !",
    "description": "Nous avons reçu votre demande de contact et nous mettons tout en oeuvre pour vous répondre dans les meilleurs délais",

    "faq_button": "Découvrir la FAQ",
    "socialmedia_button": "Nos réseaux",
    "share_button": "Recommander @:common.appname",

    "back": "Revenir à l'accueil"
  },

  // Configuration en mode FREEMIUM
  "welcome/free": {
    "information_panel_title": "Bienvenue parmi nous !",
    "information_panel_description": "Vous venez de créer votre compte chez Uska grâce à votre Office de Tourisme",

    "main_title": "Pour quel(s) établissement(s) souhaitez-vous créer votre compte ?",

    "create_establishment_loading_modal_title": "Nous créons vos établissements...",
    "create_establishment_loading_modal_description": "Nous récupérons vos informations, cela peut prendre un peu de temps",

    "free_badge": "Offert par votre OT",

    "empty_title": "Aucun établissement disponible",
    "empty_description": "Nous ne sommes pas en mesure de retrouver vos établissements existants chez votre Office de Tourisme",

    "error_title": "Une erreur est survenue",
    "error_description": "Nous ne sommes pas en mesure de retrouver vos établissements existants chez votre Office de Tourisme",

    // Bouton de contact dans les cas où on ne trouve pas d'établissements (empty ou error)
    "contact_button": "Contactez-nous",

    "all_created_title": "Aucun établissement disponible",
    "all_created_description": "Vous avez ajouté tous vos établissements disponibles chez votre Office de Tourisme",

    "next_button": "Continuer"
  },

  "welcome/free/introduction": {
    "information_panel_title": "Bienvenue parmi nous !",
    "information_panel_description": "Vous venez de créer votre compte chez Uska grâce à votre Office de tourisme",

    "main_title": "Découvrez votre nouvel espace sécurisé",
    "action_button": "Continuer",

    "free_badge": "Offert par votre OT",

    "create_establishment_loading_modal_title": "Nous créons vos établissements...",
    "create_establishment_loading_modal_description": "Vos nouveaux établissements sont désormais créés ! Vous pouvez maintenant mettre à jour vos établissements sur l'onglet \"Mes informations\" après avoir sélectionné l'établissement de votre choix.",

    "main_list": {
      "first": {
        "title": "Suivez vos performances de visibilité",
        "description": "Connectez-vous à Google et Facebook depuis “Mon tableau de bord” pour suivre vos statistiques et vos états de connexion au quotidien."
      },
      "second": {
        "title": "Actualisez vos informations à tout moment",
        "description": "Depuis “Mes Informations”, mettez facilement à jour vos informations pour votre Office de Tourisme, à tout moment, toute l’année."
      },
      "third": {
        "title": "Retrouvez les demandes de votre Office",
        "description": "Comme avant, recevez toutes les demandes de votre Office dans “Mes sollicitations”"
      },
      "fourth": {
        "title": "Analysez votre présence en ligne",
        "description": "Quelle est la qualité de vos informations sur internet ? Découvrez les premiers pas pour améliorer votre visibilité dans “Mon analyse”"
      }
    }
  },

  // CONFIGURATION

  "welcome": {
    "card_title": "Bienvenue !",
    "card_description": "Vous venez de créer votre compte. Configurez-le maintenant, en 4 étapes qui vous prendront seulement 3 minutes !",
    "button_title": "Je configure mon compte"
  },

  "configuration/begin": {
    "information_panel_title": "Configuration",
    "main_title": "Je renseigne mes informations",

    "establishment_form": {
      "main_title": "Pour commencer...",
      "subtitle": "Quel est votre établissement ?",
      "description": "Nous avons besoin de ces informations pour identifier votre établissement sur internet",
      "validation_button": "Je valide"
    },

    "establishment_address_form_validation": {
      "main_title": "Vérifiez votre adresse",
      "subtitle": "Adresse postale",
      "update_address_button": "Je modifie l'adresse",
      "show_analyse_results_button": "Suivant"
    }
  },

  "configuration/connect": {
    "empty_message": "Nous n'avons pas trouvé vos pages Google ou Facebook. Pas de panique, ça arrive, vous pourrez réessayer ultérieurement depuis votre tableau de bord.",

    "information_panel_title": "Connexion",
    "main_title": "Connectez vos comptes",
    "cancel_button": "Annuler",
    "pass_button": "Passer",
    "connect_button": "Je connecte mon compte",
    "tic_connect_button": "Envoyer une demande",
    "next_button": "Suivant",
    "retry_button": "Réessayer",
    "need_help_button": "Demander de l'aide",

    "success_connexion_message": "@:home.success_connexion_message",

    "connect_success": "Vous êtes connecté !",
    "connect_error": "Une erreur est survenue lors de la connexion à votre compte",

    "GOOGLE": {
      "title": "Connectez votre compte Google",
      "description": "La connexion à votre compte Google est nécessaire pour utiliser Uska. Elle nous apporte la majorité des informations utiles à la gestion de votre présence en ligne."
    },

    "FACEBOOK": {
      "title": "Connectez votre compte Facebook",
      "description": "La connexion à votre compte Facebook est nécessaire pour utiliser Uska. Elle nous apporte une grande partie des informations utiles à la gestion de votre présence en ligne."
    },

    // Texte pour l'office de tourisme (TIC = Tourism Information Center)
    "TIC": {
      "title": "Connectez vous avec votre office de tourisme",
      "description": "La connexion à votre Office de Tourisme permet d'améliorer votre présence en ligne et de mettre à jour plus efficacement vos informations."
    },

    "pass_modal": {
      "title": "Vous préférez vous connecter à votre compte {diffuser} plus tard ?",
      "description": "C'est possible, vous pourrez toujours vous connecter par la suite. Cependant, la connexion à votre compte maintenant est très rapide et simplifie la suite de la configuration de votre établissement. Etes-vous sûr de vouloir passer ?"
    }
  },

  "configuration/establishment": {
    "information_panel_title": "Vos informations",

    "legend": "Découvrez le formulaire et complétez vos informations. Vous pourrez revenir sur toutes vos informations par la suite.",

    "next_button": "Suivant",
    "prev_button": "Précédent"

    // find all form inputs in establishments/formulaire
  },

  "configuration/listing": {
    "information_panel_title": "Plateformes digitales",
    "main_title": "@:establishments/listing.main_title",

    "subtitle": "Découvrez vos plateformes digitales",
    "description": "Vos informations sont diffusées sur un maximum de plateformes. Cela permet d'accroître votre visibilité et d’améliorer votre référencement en ligne : vous sortez plus haut dans les résultats de recherche sur Google. Sur les plateformes où vous n’étiez pas déjà présent, nous allons automatiquement vous créer une page.",

    "legend_description": "@:establishments/listing.legend_description",
    "legend_success": "@:establishments/listing.legend_success",
    "legend_sync_in_progress":  "@:establishments/listing.legend_sync_in_progress",
    "legend_warning": "@:establishments/listing.legend_warning",
    "legend_error": "@:establishments/listing.legend_error",
    "legend_pause": "@:establishments/listing.legend_pause",

    "end_button": "Suivant",

    "alert_title": "Découvrez la liste de vos plateformes et l'état de mise à jour de vos informations",
    "alert_description": "Pour chacune de vos plateformes digitales, un état de mise à jour est indiqué. Cela vous permet d'identifier rapidement où vos informations sont à jour et où elles ne le sont pas encore.",

    "main_diffusers_title": "@:establishments/listing.main_diffusers_title",
    "main_diffusers_legend": "@:establishments/listing.main_diffusers_legend",

    "secondary_diffusers_title": "@:establishments/listing.secondary_diffusers_title",
    "secondary_diffusers_legend": "@:establishments/listing.secondary_diffusers_legend",

    "empty_list": "@:establishments/listing.empty_list",

    "end_modal": {
      "title": "Vous avez terminé de configurer votre établissement",
      "first_paragraph": "Vous venez d'enregistrer les premières informations de votre établissement, mais elles ne sont pas encore diffusées sur vos plateformes. Nous les gardons bien au chaud pour l'instant, dans Uska !",
      "list_title": "Vous avez le choix :",
      "list_item_first": "les mettre à jour maintenant, afin de les rendre visibles sur toutes vos plateformes",
      "list_item_second": "le faire plus tard, et passer à la suite directement",
      "second_paragraph": "Attention, en mettant à jour vous remplacez les données préexistantes par la donnée que vous venez de rentrer dans Uska.",
      "sync_button": "Je mets à jour maintenant et passe à la suite",
      "next_button": "Je passe à la suite"
    },

    "local_diffusers_title": "@:establishments/listing.local_diffusers_title",

    // Modale de confirmation pour lancer la mise à jour
    "sync_validate_title": "@:establishments/formulaire.sync_validate_title",
    "sync_validate_message": "@:establishments/formulaire.sync_validate_message",
    "sync_validate_button": "@:establishments/formulaire.sync_validate_button",

    // Modale de confirmation du lancement de la mise à jour
    "sync_success_message": "@:establishments/formulaire.sync_success_message",

    // Modale d'erreur du lancement de la mise à jour
    "sync_error_message": "@:establishments/formulaire.sync_error_message"
  },

  "configuration/contact": {
    "main_title": "@:common.contact_panel.button",

    "information_panel_title": "@:common.contact_panel.desription",
    "information_panel_description": "",

    "validation_title": "Votre demande de contact a bien été envoyée",
    "validation_description": "Nous avons bien pris en compte votre demande. Nous vous contacterons dans les plus brefs délais"
  },

  "google-connexion/continue": {
    "no_right_with_account": "Vous n'avez pas les droits sur cette fiche ?",
    "google_button": "Continuer avec Google"
  },

  "google-connexion/select": {
    "no_location_founded": "Vous ne trouvez pas votre fiche ?"
  }
}
